class ProductImageSelector extends HTMLElement {
	constructor() {
		super();
		this.onProductImageViewClick = this.onProductImageViewClick.bind(this);

		const productImageView1 = document.querySelector('#ProductImage1');
		if (productImageView1) productImageView1.addEventListener('click', (event) => this.onProductImageViewClick(event, 1));
		const productImageView2 = document.querySelector('#ProductImage2');
		if (productImageView2) productImageView2.addEventListener('click', (event) => this.onProductImageViewClick(event, 2));
	}

	onProductImageViewClick(event, viewNumber) {
		event.preventDefault();

		const productImageView1 = document.querySelector('#ProductImage1');
		const productImageView2 = document.querySelector('#ProductImage2');
		const productGrid = document.getElementById('product-grid');
		const productCards = Array.from(productGrid.children);

		productCards.forEach((productCard) => {
			if (viewNumber === 1) {
				productCard.querySelector('.card-wrapper.product-card-wrapper').classList.remove('secondary-image-first');
			} else {
				productCard.querySelector('.card-wrapper.product-card-wrapper').classList.add('secondary-image-first');
			}
		});

		if (viewNumber === 1) {
			productImageView1.classList.add('active');
			productImageView2.classList.remove('active');
		} else {
			productImageView1.classList.remove('active');
			productImageView2.classList.add('active');
		}
	}
}

customElements.define('product-image-selector', ProductImageSelector);